import * as React from 'react';
import { ListItem, Typography } from '@material-ui/core';
import { vote } from '../../../model/vote'

interface IProps {
    vote: vote;
    classes: any;
}

export const VoteItem = (props: IProps) => {
    const appo = new Date(props.vote.voteDate)
    const formatted = appo.toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' }) + " " + appo.toLocaleTimeString('it-IT');
    return (
        <ListItem className={props.classes.voteListItem}>
            <div className={props.classes.spreadTypography}>
                <div className={props.classes.textContainer}>
                    <Typography>{props.vote && props.vote.contact.name ? props.vote.contact.name + ' ' + props.vote.contact.surname : props.vote.contact.email}</Typography>
                </div>
                <div className={props.classes.textContainer}>
                    <Typography className={props.classes.dateTypography}>{formatted}</Typography>
                </div>
            </div>
        </ListItem>
    );
}


